import { Expose, Type } from 'class-transformer'
import { IsArray, IsObject, IsOptional, IsPositive, ValidateNested } from 'class-validator'
import { AbstractAppMessageSchedule } from '@pushly/models/lib/structs/app-messages/abstract-app-message-schedule'
import { AbstractAppMessage } from '@pushly/models/lib/structs'
import { AbstractStruct, MutableStruct } from '@pushly/models/lib/structs/abstract-struct'
import { Mutable } from '@pushly/models/lib/types/mutable'
import { IsNotEmptyString } from '@pushly/models/lib/class-validators/is-not-empty-string'
import { AppMessage } from '@pushly/models/lib/structs/app-messages/app-message'

export class AppMessageBuilderSchedulePayload extends AbstractAppMessageSchedule {}
export const MutableAppMessageBuilderSchedulePayload: MutableStruct<AppMessageBuilderSchedulePayload> =
    AppMessageBuilderSchedulePayload
export type MutableAppMessageBuilderSchedulePayload = Mutable<AppMessageBuilderSchedulePayload>

// Schedules will not have message IDObject or Model during builder flow
export class AppMessageBuilderPayload extends AbstractAppMessage {
    @Expose()
    @ValidateNested({ each: true })
    @Type(() => AppMessageBuilderSchedulePayload)
    @IsArray()
    public readonly schedules: ReadonlyArray<AppMessageBuilderSchedulePayload>
}

// @ts-ignore -- ReadonlyArray conflict
export const MutableAppMessageBuilderPayload: MutableStruct<AppMessageBuilderPayload> = AppMessageBuilderPayload
export type MutableAppMessageBuilderPayload = Mutable<AppMessageBuilderPayload>

export class ExposeUserObject extends AbstractStruct {
    @Expose()
    @IsPositive()
    public readonly id!: number

    @Expose()
    @IsNotEmptyString()
    public readonly name!: string
}

export const MutableOwnershipObject: MutableStruct<ExposeUserObject> = ExposeUserObject
export type MutableExposeUserObject = Mutable<ExposeUserObject>

export class AppMessageWithExposeUserObject extends AppMessage {
    @Expose()
    @ValidateNested()
    @Type((_) => ExposeUserObject)
    @IsObject()
    public readonly creator!: ExposeUserObject

    @Expose()
    @ValidateNested()
    @Type((_) => ExposeUserObject)
    @IsObject()
    public readonly updater!: ExposeUserObject
}
